import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-slate-900 border-t border-slate-800 text-slate-400 py-12">
      <div className="container mx-auto px-6 lg:px-12 flex flex-col gap-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center select-none">
            <img 
              src="/jobisawhite.png" 
              alt="jobisa" 
              className="h-12 w-auto"
            />
          </div>
          <div className="flex gap-8 text-sm font-medium flex-wrap justify-center">
            <a href="/privacy-policy" className="hover:text-jobisa-yellow transition-colors">{t('footer.privacy')}</a>
            <a href="/terms-and-conditions" className="hover:text-jobisa-yellow transition-colors">{t('footer.terms')}</a>
            <a href="/delete-data" className="hover:text-jobisa-yellow transition-colors">Data Deletion</a>
            <a href="mailto:hiring@jobisa.in" className="hover:text-jobisa-yellow transition-colors">hiring@jobisa.in</a>
          </div>
          <div className="text-sm">
            {t('footer.rights')}
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 flex flex-col md:flex-row justify-between gap-4 text-sm text-slate-500">
          <div>
            Jobisa is a brand owned and operated by Chelvi Engineers and Consultant
          </div>
          <div>
            A Made-in-India initiative for the Global Workforce.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
